// Single source of truth for per-route SEO metadata used by the build-time
// prerender (scripts/prerender.mjs). These values MUST stay in sync with the
// <SEOHead> props rendered by each page in src/pages/* and with the blog
// metadata in src/data/blogData.tsx. A guard test (src/test/seo-routes.test.ts)
// verifies the blog entries below match src/data/blogData.tsx.

export const SITE_URL = "https://proimpact.ch";

// Date of the last change to the HTML served for non-blog pages (blog pages
// use their own modifiedTime). Bump when the prerendered content changes.
export const CONTENT_UPDATED = "2026-11-04";

const SUFFIX = " | ProImpact Carrosserie";

// Blog articles - title/description/dates mirror src/data/blogData.tsx.
export const blogRoutes = [
  {
    slug: "debosselage-geneve-bosses-parking-hiver",
    title: "Bosses de parking à Genève : que faire et comment les réparer",
    description:
      "Bosse de portière, chariot, pilier de parking : les bons réflexes à Genève, qui paie la réparation et comment la bosse se répare par redressage et peinture.",
    publishedTime: "2026-11-04",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "accrochage-geneve-constat-amiable",
    title: "Accrochage à Genève : réflexes et constat amiable",
    description:
      "Accrochage à Genève sans blessé : sécuriser les lieux, savoir s'il faut appeler la police, remplir le constat amiable et préparer la suite.",
    publishedTime: "2026-11-04",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "casco-ou-rc-qui-paie-reparation-carrosserie",
    title: "Casco ou RC : qui paie votre réparation carrosserie ?",
    description:
      "RC, casco partielle ou casco complète : qui paie la réparation de votre carrosserie en Suisse ? Cas concrets, franchise, bonus et gestion du sinistre.",
    publishedTime: "2026-11-04",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "carrosserie-carouge-reparation-voiture",
    title: "Carrosserie à Carouge : dégâts typiques et solutions",
    description:
      "Rayures, bosses de manœuvre, pare-chocs touchés : les dégâts les plus fréquents à Carouge et comment les faire réparer sans perdre votre journée.",
    publishedTime: "2026-11-04",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "choisir-carrosserie-geneve",
    title: "Guide Complet : Choisir sa Carrosserie à Genève",
    description:
      "Tous nos conseils pour choisir le bon carrossier à Genève. Certifications, équipements, gestion assurance, délais : ce qu'il faut vérifier avant de confier votre véhicule.",
    publishedTime: "2025-02-15",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "sinistre-auto-assurance-suisse",
    title: "Sinistre Auto en Suisse : Les Démarches d'Assurance",
    description:
      "Accident, accrochage, sinistre auto : quelles sont les démarches à effectuer avec votre assurance en Suisse ? Notre guide complet étape par étape.",
    publishedTime: "2025-02-05",
    modifiedTime: "2026-06-29",
  },
  {
    slug: "entretien-peinture-voiture-conseils",
    title: "Entretien Carrosserie : 10 Conseils pour Protéger la Peinture",
    description:
      "Comment protéger et entretenir la peinture de votre voiture ? 10 conseils d'expert pour préserver l'éclat de votre carrosserie et éviter les dégradations.",
    publishedTime: "2025-01-28",
    modifiedTime: "2026-11-04",
  },
  {
    slug: "peinture-voiture-metallisee-nacre-mat",
    title: "Peinture Voiture : Teinte Métallisée, Nacré ou Mat ?",
    description:
      "Vous devez repeindre votre véhicule ou hésitez sur une teinte ? Métallisé, nacré, mat : explications, avantages, entretien, coût. Notre guide complet.",
    publishedTime: "2025-01-12",
    modifiedTime: "2026-06-29",
  },
];

// Service sub-pages - seoTitle/metaDescription mirror src/data/servicesData.tsx
// (verified by src/test/seo-routes.test.ts). Page <title> = `${seoTitle} | ProImpact`.
export const serviceRoutes = [
  {
    slug: "tolerie-peinture",
    name: "Tôlerie & Peinture",
    seoTitle: "Réparation carrosserie à Genève : accident, rayures, grêle",
    metaDescription:
      "Carrosserie à Genève : accident, accrochage, bosses, rayures et grêle réparés par tôlerie et peinture. Assurance gérée, prise en charge dans tout le canton.",
  },
  {
    slug: "pare-brise",
    name: "Pare-brise",
    seoTitle: "Pare-brise à Genève : réparation et remplacement",
    metaDescription:
      "Réparation et remplacement de pare-brise à Genève. Bris de glace souvent couvert par la casco partielle, assurance gérée, voiture prise et rendue chez vous.",
  },
  {
    slug: "gestion-sinistre",
    name: "Gestion de sinistre",
    seoTitle: "Gestion de Sinistre Auto & Assurance à Genève",
    metaDescription:
      "Sinistre auto à Genève : nous gérons tout le dossier avec votre assurance (AXA, Zurich, Allianz, Helvetia, Mobilière…). Vous ne payez que votre franchise. Devis gratuit 24h.",
  },
];

// Pages locales par commune - seoTitle/metaDescription mirror
// src/data/communesData.tsx (verified by src/test/seo-routes.test.ts).
export const communeRoutes = [
  {
    slug: "carouge",
    name: "Carouge",
    seoTitle: "Carrosserie à Carouge",
    metaDescription:
      "Carrossier à Carouge : tôlerie, peinture, pare-brise et gestion de sinistre. Atelier ProImpact tout proche, devis gratuit 24h. ☎ +41 76 638 86 55",
  },
  {
    slug: "vernier",
    name: "Vernier",
    seoTitle: "Carrosserie à Vernier",
    metaDescription:
      "Carrossier à Vernier : réparation tôlerie & peinture, pare-brise et sinistre assurance. ProImpact, devis gratuit 24h. ☎ +41 76 638 86 55",
  },
  {
    slug: "meyrin",
    name: "Meyrin",
    seoTitle: "Carrosserie à Meyrin",
    metaDescription:
      "Carrossier à Meyrin : tôlerie, peinture, pare-brise et gestion de sinistre. ProImpact, devis gratuit sous 24h. ☎ +41 76 638 86 55",
  },
  {
    slug: "lancy",
    name: "Lancy",
    seoTitle: "Carrosserie à Lancy",
    metaDescription:
      "Carrossier à Lancy (Grand-Lancy, Petit-Lancy) : tôlerie & peinture, pare-brise et sinistre assurance. ProImpact, devis gratuit 24h. ☎ +41 76 638 86 55",
  },
];

// All prerendered routes (entries with noindex: true are kept out of the sitemap). `out` is the file path (relative to dist/) written by
// the prerender. The homepage keeps dist/index.html.
export const routes = [
  {
    path: "/",
    out: "index.html",
    title: "ProImpact Carrosserie Genève | Tôlerie & Peinture",
    description:
      "Expert carrosserie à Genève. Gestion sinistre assurance complète, tôlerie, peinture, pare-brise. Devis gratuit 24h. ☎ +41 76 638 86 55",
    heading: "ProImpact Carrosserie Genève - Tôlerie & Peinture",
    ogType: "website",
  },
  {
    path: "/blog",
    out: "blog/index.html",
    title: "Blog ProImpact | Conseils Carrosserie Genève",
    description:
      "Conseils d'experts, guides pratiques et actualités sur la carrosserie automobile à Genève. Tôlerie, peinture, pare-brise et assurance.",
    heading: "Blog ProImpact - Conseils carrosserie à Genève",
    ogType: "website",
  },
  ...blogRoutes.map((a) => ({
    path: `/blog/${a.slug}`,
    out: `blog/${a.slug}/index.html`,
    title: `${a.title}${SUFFIX}`,
    description: a.description,
    heading: a.title,
    ogType: "article",
    publishedTime: a.publishedTime,
    modifiedTime: a.modifiedTime,
  })),
  {
    path: "/services",
    out: "services/index.html",
    title: "Nos Services Carrosserie à Genève | ProImpact",
    description:
      "Les services de ProImpact Carrosserie à Genève : réparation carrosserie (tôlerie, peinture, bosses, rayures, grêle), pare-brise et gestion de sinistre avec l'assurance.",
    heading: "Nos services carrosserie à Genève",
    ogType: "website",
  },
  ...serviceRoutes.map((s) => ({
    path: `/services/${s.slug}`,
    out: `services/${s.slug}/index.html`,
    title: `${s.seoTitle} | ProImpact`,
    description: s.metaDescription,
    heading: s.seoTitle,
    ogType: "website",
  })),
  {
    path: "/a-propos",
    out: "a-propos/index.html",
    title: "À Propos | ProImpact Carrosserie à Genève",
    description:
      "ProImpact Carrosserie, atelier indépendant à Genève spécialisé en tôlerie, peinture et pare-brise. Équipement de pointe et gestion assurance complète.",
    heading: "Votre carrossier de confiance à Genève",
    ogType: "website",
  },
  {
    path: "/contact",
    out: "contact/index.html",
    title: "Contact & Devis Gratuit | ProImpact Carrosserie Genève",
    description:
      "Contactez ProImpact Carrosserie à Genève (Rue Voltaire 22, 1201 Genève). Téléphone, WhatsApp, email et formulaire de devis gratuit. Ouvert 24h/24, 7j/7.",
    heading: "Contact & devis gratuit",
    ogType: "website",
  },
  ...communeRoutes.map((c) => ({
    path: `/carrosserie-${c.slug}`,
    out: `carrosserie-${c.slug}/index.html`,
    title: `${c.seoTitle} | ProImpact Carrosserie`,
    description: c.metaDescription,
    heading: `Carrosserie à ${c.name}`,
    ogType: "website",
  })),
  {
    path: "/mentions-legales",
    out: "mentions-legales/index.html",
    title: "Mentions Légales | ProImpact Carrosserie Genève",
    description:
      "Mentions légales de ProImpact Carrosserie, carrossier à Genève. Informations sur l'éditeur, l'hébergement et la propriété intellectuelle.",
    heading: "Mentions légales",
    ogType: "website",
  },
  {
    path: "/politique-confidentialite",
    out: "politique-confidentialite/index.html",
    title: "Politique de Confidentialité | ProImpact Carrosserie",
    description:
      "Politique de confidentialité de ProImpact Carrosserie. Informations sur la collecte et le traitement de vos données personnelles.",
    heading: "Politique de confidentialité",
    ogType: "website",
  },
  {
    path: "/plan-du-site",
    out: "plan-du-site/index.html",
    title: "Plan du Site | ProImpact Carrosserie Genève",
    description:
      "Plan du site ProImpact Carrosserie. Retrouvez toutes les pages : services, blog, mentions légales.",
    heading: "Plan du site",
    ogType: "website",
  },
  // Review request page sent to customers: prerendered with noindex, and
  // therefore excluded from sitemap.xml by the prerender.
  {
    path: "/avis",
    out: "avis/index.html",
    title: "Votre avis | ProImpact Carrosserie",
    description: "Merci de votre confiance ! Laissez un avis Google à ProImpact Carrosserie Genève.",
    heading: "Merci de votre confiance !",
    ogType: "website",
    noindex: true,
  },
];

// Removed pages (services ProImpact does not offer). Lovable hosting ignores
// public/_redirects, so the prerender writes a stub at each old URL that
// redirects instantly (meta refresh + location.replace, canonical to the
// target, noindex) and App.tsx redirects client-side navigations. The same
// pairs are mirrored as 301 rules in public/_redirects for other hosts.
export const redirects = [
  { from: "/services/debosselage-pdr", to: "/services/tolerie-peinture" },
  { from: "/services/reparation-jantes", to: "/services" },
  { from: "/services/detailing", to: "/services" },
  { from: "/blog/debosselage-sans-peinture-pdr", to: "/services/tolerie-peinture" },
  { from: "/blog/reparer-remplacer-jante-abimee", to: "/services" },
  { from: "/blog/jantes-abimees-trottoir-hiver-geneve", to: "/services" },
];

// 404 page - rendered to dist/404.html, served by the host for unmatched URLs.
export const notFoundRoute = {
  path: "/404",
  out: "404.html",
  title: "Page introuvable | ProImpact Carrosserie",
  description: "Cette page n'existe pas ou a été déplacée.",
  heading: "Page introuvable",
  ogType: "website",
  noindex: true,
};
